import { AccountGroup } from 'companion-app-components/flux/account-groups/accountGroupsTypes';
import { deriveAccountGroupdIds } from 'companion-app-components/flux/account-groups/accountGroupUtils';
import { DatasetShare } from 'companion-app-components/flux/dataset-shares/datasetSharesTypes';
import { stringToColor } from 'containers/App/Header/ProfileMenu/utils';
import { applyOpacityToHex } from 'themes/themeUtils';

export const stringAvatar = (name: string) => {
  const nameParts = name.split(' ');
  return {
    sx: {
      bgcolor: applyOpacityToHex(stringToColor(name), 0.6),
      fontSize: 16,
      width: 45, 
      height: 45,
      color: 'shadowGrey',
      fontWeight: 500,
      textTransform: 'uppercase',
    },
    children: nameParts.length > 1 
      ? `${nameParts[0][0]}${nameParts[1][0]}` 
      : `${nameParts[0][0]}`,
  };
};

export const membersOptions = [{
  label: 'Resend Invitation',
  action: 'resend',
  types: ['INVITED', 'ABANDONED'],
  eventName: 'resendInvitation', 
}, {
  label: 'Revoke Invitation',
  action: 'revoke',
  types: ['INVITED'],
  eventName: 'revokeInvitation',
}, {
  label: 'Remove Member',
  action: 'remove',
  types: ['ACCEPTED', 'ACTIVE', 'ABANDONED'],
  eventName: 'removeAccess',
}];

export const capitalizeString = (str: string) => str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

export const hasDatasetFullAccess = (_accountGroups: AccountGroup[], share?: DatasetShare) => {
  if (!share?.itemAccessControl) {
    return true;
  }

  const sharedAccountGroupIds = deriveAccountGroupdIds(
    share?.itemAccessControl?.resources?.ACCOUNT_GROUP,
    ['write', 'read'],
  );

  return sharedAccountGroupIds.length === 2
    && sharedAccountGroupIds.every((accountGroupId) => accountGroupId === '*');
};

export const getCFOEntityAccessTrackingProps = (
  fullAccess: boolean,
  entityCount: number,
  read?: string[],
  write?: string[],
) => {
  const readLength = read?.length || 0;
  const writeLength = write?.length || 0;

  return {
    access_type: fullAccess ? 'full access' : 'custom access',
    entity_count: entityCount,
    entity_shared: readLength + writeLength,
    entity_view_shared: readLength,
    entity_edit_shared: writeLength,
  };
};

export const canShowChangePermissionOption = (
  hasDatasetEntityPermissions: boolean,
  hasShareableAccountGroups: boolean,
  isOwnerViewingSharedDataset: boolean,
  shareState?: string,
) => (
  hasDatasetEntityPermissions
  && hasShareableAccountGroups
  && isOwnerViewingSharedDataset
  && shareState !== 'ABANDONED'
);
